import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { AppUpdateNotice } from './components/AppUpdateNotice.js';
import './styles.css';
import { log } from './env.js';
import { keepSessionFresh } from './api.js';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

// Swallow file drops that miss a dropzone. Without this the browser's default
// takes over and NAVIGATES to the dropped file — which, for the inspector, looks
// like "drag and drop just opens the photo in a new tab" and silently loses the
// draft's unsaved screen state. Individual dropzones call preventDefault
// themselves and stop propagation is unnecessary: this only ever sees drops
// that no zone handled.
for (const type of ['dragover', 'drop'] as const) {
  window.addEventListener(type, (event) => event.preventDefault());
}

createRoot(rootEl).render(
  <React.StrictMode>
    <AppUpdateNotice />
    <App />
  </React.StrictMode>,
);

// Runs for the life of the tab — the teardown handle is only for tests.
keepSessionFresh();

// Load the report-validation and upload stack after React has rendered the
// shell. Sync still starts on boot, but its large schemas no longer block the
// first useful screen on a weak field connection.
void import('./sync/index.js')
  .then(({ attachOnlineSyncListener, runSync }) => {
    attachOnlineSyncListener();
    return runSync();
  })
  .catch((e) => log('initial sync failed', e));
